import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
}

export const AdditionalInfoTab = ({ formMode }: Props) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mô tả</Label>
          <div className='w-full'>
            <FormField name='description' type='text' disabled={formMode === 'view'} />
          </div>
        </div>
      </div>
    </div>
  );
};
